<template>
  <DesktopLayout :header-panel="ABOVE_MAP">
    <MapWrapper
      v-if="!customVisualisationActive"
      :show-popups="showPopups"
      :show-bounds="showBounds"
      data-test="map-wrapper"
    />
    <CustomVisualisation
      v-if="customVisualisationActive"
      data-test="custom-visualisation"
    />
  </DesktopLayout>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import DesktopLayout from '@/components/public/DesktopLayout/DesktopLayout.vue'
import MapWrapper from '@/components/public/TheMap/MapWrapper.vue'
import CustomVisualisation from '@/components/public/CustomVisualisation.vue'
import { StoryKeys } from '@/types'
import { ROUTE_PUBLIC } from '@/constants'
import router from '@/router'

const components = {
  DesktopLayout,
  MapWrapper,
  CustomVisualisation,
}

const props = {
  showPopups: {
    type: Boolean,
    default: true,
  },
  showBounds: {
    type: Boolean,
    default: false,
  },
}

@Component({
  components,
  watch: {
    showMap (show) {
      if (!show) {
        router.push({
          name: ROUTE_PUBLIC,
        })
      }
    },
  },
})
export default class MapView extends Vue.extend({ props }) {
  ABOVE_MAP = StoryKeys.ABOVE_MAP

  get showMap () {
    return this.$typedStore.visualisationApp.showMap
  }

  get customVisualisationActive () {
    return this.$typedStore.activeVisualisation.isCustom
  }
}

</script>
